import React, {
  Component,
} from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import RaisedButton from 'material-ui/RaisedButton';
import styled from 'styled-components';
import {
  BODY_TEXT_COLOR,
  NEGATIVE_COLOR,
} from '../../config/colors';
import {
  TextDiv,
} from '../../modals';
import CustomerType from '../../const/customer_type';
import { EMPTY_STRING } from '../../const/string';

const styles = {
  button: { width: '180px', fontWeight: 700 },
  secondaryButtonColor: NEGATIVE_COLOR,
  labelStyle: { fontWeight: 700 },
};

const OK = 'Ok';
const CANCEL = 'Cancel';
const BUTTON_LABEL_COLOR = '#FFF';

class CustomerTypeMismatchModelContent extends Component {
  getSecondaryColor() {
    const {
      secondaryColor,
    } = this.props;

    return `#${secondaryColor}`;
  }

  onCancel = () => {
    const {
      onCancel,
    } = this.props;

    if (onCancel) {
      onCancel();
    }
  };

  onOk = () => {
    const {
      onOk,
    } = this.props;

    if (onOk) {
      onOk();
    }
  };

  getCurrentCustomerTypeStartCase() {
    const {
      currentCustomerType,
    } = this.props;

    return currentCustomerType ? _.startCase(_.toLower(currentCustomerType)) : EMPTY_STRING;
  }

  getText() {
    const {
      currentCustomerType,
    } = this.props;

    return currentCustomerType === CustomerType.ADULT
      ? `${this.getCurrentCustomerTypeStartCase()} customers can only purchase recreational inventory,
        and medical items will be removed from cart.`
      : `${this.getCurrentCustomerTypeStartCase()} customers can only purchase medical inventory,
        and recreational items will be removed from cart.`;
  }

  renderCustomerTypeButtons() {
    return (
      [
        <RaisedButton
          key={CANCEL}
          onClick={this.onCancel}
          backgroundColor={styles.secondaryButtonColor}
          labelColor={BUTTON_LABEL_COLOR}
          label={CANCEL}
          labelStyle={styles.labelStyle}
          style={styles.button}
        />,
        <RaisedButton
          key={OK}
          onClick={this.onOk}
          backgroundColor={this.getSecondaryColor()}
          labelColor={BUTTON_LABEL_COLOR}
          labelStyle={styles.labelStyle}
          label={OK}
          style={styles.button}
        />,
      ]
    );
  }

  renderButtons() {
    return (
      <ButtonsWrapperDiv>
        {this.renderCustomerTypeButtons()}
      </ButtonsWrapperDiv>
    );
  }

  render() {
    return (
      <ModalWrapperDiv>
        <TextDiv>
          <div style={{ padding: '0 18px' }}>
            {this.getText()}
          </div>
        </TextDiv>
        {this.renderButtons()}
      </ModalWrapperDiv>
    );
  }
}

CustomerTypeMismatchModelContent.propTypes = {
  secondaryColor: PropTypes.string.isRequired,
  currentCustomerType: PropTypes.string.isRequired,
  onCancel: PropTypes.func.isRequired,
  onOk: PropTypes.func.isRequired,
};

export default CustomerTypeMismatchModelContent;

const ModalWrapperDiv = styled.div`
  display: flex;
  color: ${BODY_TEXT_COLOR};
  flex-direction: column;
  font-size: 18px;
  align-items: center;
  justify-content: center;
  margin: 20px auto 20px;
  height: 100%;
`;

const ButtonsWrapperDiv = styled.div`
  display: flex;
  justify-content: space-between;
  width: 366px;
  @media (max-width: 768px) {
    width: 355px;
    flex-direction: column;
    align-items: center;
    & > div {
      margin-bottom: 5px;
    }
  }
`;



// WEBPACK FOOTER //
// ./src/components/CustomerTypeMismatchModelContent/customer_type_mismatch_model_content.jsx